import { render, staticRenderFns } from "./NotificationsMenu.vue?vue&type=template&id=1ef9ea92&scoped=true&"
import script from "./NotificationsMenu.vue?vue&type=script&lang=ts&"
export * from "./NotificationsMenu.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationsMenu.vue?vue&type=style&index=0&id=1ef9ea92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef9ea92",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBadge,VBtn,VCard,VCardActions,VIcon,VMenu,VSpacer,VTooltip})
